import React from 'react';
import { CircularProgress } from "@material-ui/core";
import Translator from "Languages/Utility/Translator";

function InnerCircularProgress() {
  return (
    <div className="InnerCircularProgress p-4">
        <div className="mb-3">
            <CircularProgress color="inherit" size={35} thickness={2} />
        </div>
        <Translator id={'pleaseWait'} />
    </div>
  );
}

export default InnerCircularProgress;
